// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductCompareCarouselStyles } from "@awc/Overrides/Widgets/ProductCompare/ProductCompareCarousel";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import X from "@insite/mobius/Icons/X";
import { css } from "styled-components";

ProductCompareCarouselStyles.navigationButton = {
    variant: "secondary",
    css: css`
        margin-bottom: 24px;
    `,
};

ProductCompareCarouselStyles.headerButtonsGridItem = {
    width: 12,
    css: css`
        gap: 10px;
        align-items: center;
    `,
};

ProductCompareCarouselStyles.headerGridItem = {
    width: 12,
    css: css`
        width: 100%;
        padding: 12px;
        border: 1px solid ${color("common.ui27")};
        &&& {
            margin-bottom: 24px;
        }
    `,
};

ProductCompareCarouselStyles.headerRemoveAllButton = {
    variant: "tertiary",
    sizeVariant: "small",
};

ProductCompareCarouselStyles.container = { gap: 0 };

ProductCompareCarouselStyles.headerTextGridItem = { width: 12 };
ProductCompareCarouselStyles.navigationLinkGridItem = { width: 12 };

ProductCompareCarouselStyles.productsCount = {
    color: "primary",
    size: fontConfig.fontSize.singleLineRegular,
    lineHeight: fontConfig.lineHeight.singleLineRegular,
};

ProductCompareCarouselStyles.removeProductFromCompareClickable = {
    css: css`
        position: absolute;
        right: 0;
        &&& {
            width: unset;
            height: unset;
        }
        ${IconWrapper} {
            color: ${color("primary")};
        }
        &:hover {
            ${IconWrapper} {
                color: ${color("common.ui8")};
            }
        }
    `,
};

ProductCompareCarouselStyles.removeProductFromCompareButtonIcon = {
    src: X,
    size: 15,
};
